export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Outcome'
    },
    unique: [],
    lang: {
        name: 'Play Outcome',
        category: ['User', 'Plays'],
        description: 'Whether the play was won, lost, or had no win/loss tracked.',
        views: ['list', 'sheet'],
    },
    filters: ['play.outcome']
}
